import React from 'react';
import Info from "../controls/Info";

function Label(props) {
    
    var info = props.InfoToolTip;

    return (
        <td className={props.className || "label"}>
            <label className='control-label'>
                {props.Label}
                {info && <Info ToolTip={props.InfoToolTip} />}
            </label>
        </td>
    )
}

export default Label;